import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Award, PlayCircle } from "lucide-react";

export default function Courses() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [courses, setCourses] = useState([]);
  const [enrollments, setEnrollments] = useState([]);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data)).catch(() => {});
    if (user.role === "staff") api.get("/enrollments/me").then((r) => setEnrollments(r.data)).catch(() => {});
  }, [user.role]);

  const enrolFor = (cid) => enrollments.find((e) => e.course_id === cid);

  return (
    <div>
      <PageHeader title="Course library" subtitle="On-demand video training your whole team can complete on any device." />
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        {courses.map((c) => {
          const enr = enrolFor(c.id);
          return (
            <div key={c.id} data-testid={`course-card-${c.id}`} className="bg-cream-card border border-cream-deep rounded-2xl overflow-hidden transition-transform duration-150 hover:-translate-y-1 hover:shadow-md flex flex-col">
              <div className="h-40 bg-cream-deep relative">
                {c.thumbnail && <img src={c.thumbnail} alt={c.title} className="w-full h-full object-cover" />}
                <Badge className="absolute top-3 left-3 bg-brand text-white hover:bg-brand">{c.category}</Badge>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading font-bold text-brand text-lg">{c.title}</h3>
                <p className="text-sm text-muted-foreground mt-2 line-clamp-2 flex-1">{c.description}</p>
                <div className="flex items-center gap-4 mt-4 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1"><PlayCircle className="h-3.5 w-3.5" />{c.lessons?.length || 0} lessons</span>
                  <span className="flex items-center gap-1"><Award className="h-3.5 w-3.5" />{c.cpd_hours} CPD hrs</span>
                </div>
                {enr && (
                  <div className="mt-3 h-2 bg-cream-deep rounded-full overflow-hidden">
                    <div className="h-full bg-rag-green rounded-full" style={{ width: `${enr.progress}%` }} />
                  </div>
                )}
                <Button data-testid={`open-course-${c.id}`} onClick={() => nav(`/app/courses/${c.id}`)} className="mt-4 rounded-full bg-brand hover:bg-brand-hover text-white w-full">
                  {enr ? (enr.status === "completed" ? "Review course" : "Continue") : "View course"}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
